/* GM Nest Co — shared cart actions (Add to Cart / Buy Now / variant picker modal)
   Used by the homepage grid AND the standard Shopify product cards (collection, search, etc).
   Loaded once, site-wide, from layout/theme.liquid. */

if (!window.gmnCardNavigate) {
  window.gmnCardNavigate = function (event, card) {
    if (event.target.closest('.gmn-product-card__add-btn') || event.target.closest('.gmn-product-card__buy-now-btn')) return;
    var url = card.getAttribute('data-product-url');
    if (url) window.location.href = url;
  };
}

if (!window.gmnRefreshCartBubble) {
  window.gmnRefreshCartBubble = function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var icon = document.getElementById('cart-icon-bubble');
        if (!icon) return;
        var bubble = icon.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            icon.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">' + cart.item_count + ' items</span>';
        }
      })
      .catch(function () {});
  };
}

if (!window.gmnAddToCart) {
  window.gmnAddToCart = function (event, btn) {
    event.preventDefault();
    event.stopPropagation();

    if (btn.getAttribute('data-multi') === 'true') {
      gmnOpenVariantModal(btn);
      return;
    }

    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var variantId = btn.getAttribute('data-variant-id');
    var label = btn.querySelector('.gmn-add-btn__label');
    var originalText = label.textContent;
    btn.classList.add('is-loading');
    label.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Could not add to cart'); }
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        label.textContent = 'Added \u2713';
        gmnRefreshCartBubble();

        setTimeout(function () {
          btn.classList.remove('is-added');
          label.textContent = originalText;
        }, 1800);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        label.textContent = 'Try Again';
        setTimeout(function () { label.textContent = originalText; }, 1800);
        console.error('GMN add to cart error:', err);
      });
  };
}

if (!window.gmnModalState) {
  window.gmnModalState = { variants: [], selected: {}, options: [] };
}

if (!window.gmnEnsureModal) {
  window.gmnEnsureModal = function () {
    if (document.getElementById('gmn-variant-modal-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'gmn-variant-modal-overlay';
    overlay.className = 'gmn-variant-modal-overlay';
    overlay.innerHTML =
      '<div class="gmn-variant-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="gmn-variant-modal__close" aria-label="Close">&times;</button>' +
        '<div class="gmn-variant-modal__image-wrap"><img class="gmn-variant-modal__image" src="" alt=""></div>' +
        '<h3 class="gmn-variant-modal__title"></h3>' +
        '<p class="gmn-variant-modal__price"></p>' +
        '<p class="gmn-variant-modal__prompt">Please select your options:</p>' +
        '<div class="gmn-variant-modal__options"></div>' +
        '<button type="button" class="gmn-variant-modal__confirm" disabled>Select options</button>' +
        '<p class="gmn-variant-modal__status"></p>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) gmnCloseModal();
    });
    overlay.querySelector('.gmn-variant-modal__close').addEventListener('click', gmnCloseModal);
  };
}

if (!window.gmnCloseModal) {
  window.gmnCloseModal = function () {
    var overlay = document.getElementById('gmn-variant-modal-overlay');
    if (overlay) overlay.classList.remove('is-open');
  };
}

if (!window.gmnOpenVariantModal) {
  window.gmnOpenVariantModal = function (btn) {
    gmnEnsureModal();
    var options = JSON.parse(btn.getAttribute('data-options'));
    var variants = JSON.parse(btn.getAttribute('data-variants'));
    var title = btn.getAttribute('data-product-title');

    window.gmnModalState = { variants: variants, selected: {}, options: options };
    var defaultVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
    options.forEach(function (opt, idx) {
      window.gmnModalState.selected[opt.name] = defaultVariant ? defaultVariant.options[idx] : null;
    });

    var overlay = document.getElementById('gmn-variant-modal-overlay');
    overlay.querySelector('.gmn-variant-modal__title').textContent = title;
    overlay.querySelector('.gmn-variant-modal__status').textContent = '';
    gmnRenderModalOptions();
    overlay.querySelector('.gmn-variant-modal__confirm').onclick = function () { gmnConfirmAddToCart(); };
    overlay.classList.add('is-open');
  };
}

if (!window.gmnFindMatchingVariant) {
  window.gmnFindMatchingVariant = function () {
    var state = window.gmnModalState;
    var optNames = state.options.map(function (o) { return o.name; });
    var matches = state.variants.filter(function (v) {
      return optNames.every(function (name, i) { return v.options[i] === state.selected[name]; });
    });
    return matches[0];
  };
}

if (!window.gmnRenderModalOptions) {
  window.gmnRenderModalOptions = function () {
    var overlay = document.getElementById('gmn-variant-modal-overlay');
    var container = overlay.querySelector('.gmn-variant-modal__options');
    container.innerHTML = '';
    var state = window.gmnModalState;
    var optNames = state.options.map(function (o) { return o.name; });

    state.options.forEach(function (opt) {
      var group = document.createElement('div');
      group.className = 'gmn-variant-modal__option';
      var label = document.createElement('span');
      label.className = 'gmn-variant-modal__option-label';
      label.textContent = opt.name;
      group.appendChild(label);

      var valuesWrap = document.createElement('div');
      valuesWrap.className = 'gmn-variant-modal__values';

      opt.values.forEach(function (val) {
        var vbtn = document.createElement('button');
        vbtn.type = 'button';
        vbtn.textContent = val;
        vbtn.className = 'gmn-variant-value-btn';
        if (state.selected[opt.name] === val) vbtn.classList.add('is-selected');

        var testSelected = Object.assign({}, state.selected);
        testSelected[opt.name] = val;
        var hasAvailable = state.variants.some(function (v) {
          return v.available && optNames.every(function (name, i) { return v.options[i] === testSelected[name]; });
        });
        if (!hasAvailable) vbtn.classList.add('is-unavailable');

        vbtn.addEventListener('click', function () {
          state.selected[opt.name] = val;
          gmnRenderModalOptions();
        });
        valuesWrap.appendChild(vbtn);
      });

      group.appendChild(valuesWrap);
      container.appendChild(group);
    });

    gmnUpdateModalConfirmState();
  };
}

if (!window.gmnUpdateModalConfirmState) {
  window.gmnUpdateModalConfirmState = function () {
    var overlay = document.getElementById('gmn-variant-modal-overlay');
    var confirmBtn = overlay.querySelector('.gmn-variant-modal__confirm');
    var priceEl = overlay.querySelector('.gmn-variant-modal__price');
    var imageEl = overlay.querySelector('.gmn-variant-modal__image');
    var match = gmnFindMatchingVariant();

    if (match && match.image) {
      imageEl.src = match.image;
    }

    if (match && match.available) {
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Add to Cart';
      priceEl.textContent = match.price || '';
    } else if (match && !match.available) {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Sold Out';
      priceEl.textContent = match.price || '';
    } else {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'Select options';
      priceEl.textContent = '';
    }
  };
}

if (!window.gmnConfirmAddToCart) {
  window.gmnConfirmAddToCart = function () {
    var match = gmnFindMatchingVariant();
    if (!match || !match.available) return;
    var overlay = document.getElementById('gmn-variant-modal-overlay');
    var confirmBtn = overlay.querySelector('.gmn-variant-modal__confirm');
    var statusEl = overlay.querySelector('.gmn-variant-modal__status');
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: match.id, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) { throw new Error(data.description || 'Could not add to cart'); }
        statusEl.textContent = 'Added to cart!';
        gmnRefreshCartBubble();
        setTimeout(function () { gmnCloseModal(); }, 900);
      })
      .catch(function (err) {
        statusEl.textContent = 'Something went wrong \u2014 try again.';
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Add to Cart';
        console.error('GMN modal add to cart error:', err);
      });
  };
}
